import { useMemo } from "react";
import PhoneInput from "react-phone-number-input";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import "react-phone-number-input/style.css";

const normalisePhone = (value, defaultCountry = "GB") => {
  const rawValue = String(value || "").trim();
  if (!rawValue) return "";

  const phone = parsePhoneNumberFromString(
    rawValue.replace(/^00/, "+"),
    defaultCountry,
  );
  return phone?.number || "";
};

const NewMobileNumberInput = ({
  id,
  label,
  value,
  onChange,
  required = false,
  disabled = false,
  defaultCountry = "GB",
  placeholder = "Telephone number",
  error = "",
}) => {
  const inputId =
    id ||
    `phone-${String(label || "field")
      .replace(/\s+/g, "-")
      .toLowerCase()}`;
  const phoneValue = useMemo(
    () => normalisePhone(value, defaultCountry) || undefined,
    [value, defaultCountry],
  );

  return (
    <div className="AnnouncementInputField">
      {label && (
        <label
          htmlFor={inputId}
          className="AnnouncementInputField__Label FP_Content text-black"
        >
          {label}{" "}
          {required && (
            <span className="FP_Content_Semibold text-error">*</span>
          )}
        </label>
      )}
      <PhoneInput
        id={inputId}
        value={phoneValue}
        onChange={(nextValue) =>
          onChange?.(normalisePhone(nextValue, defaultCountry))
        }
        placeholder={placeholder}
        defaultCountry={defaultCountry}
        international
        withCountryCallingCode
        countryCallingCodeEditable={false}
        disabled={disabled}
        className={`fp-form-input FP_Content text-black ${error ? "fp-form-input--error" : ""}`}
      />
      {error && <p className="AnnouncementInputField__Error">{error}</p>}
    </div>
  );
};

export default NewMobileNumberInput;
